import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import type React from 'react';

import { Carousel } from '@/core/tamagoshi/Carousel/Carousel';
import {
  ChipLink,
  type ClickTracking,
} from '@/domains/productDiscovery/Listings/components/ChipLink/ChipLink';

import { title } from './translations';

import styles from './NavigationLinks.module.scss';

export type { ClickTracking } from '@/domains/productDiscovery/Listings/components/ChipLink/ChipLink';

export interface Link {
  id: number;
  name: string;
  url: string;
  isSelected?: boolean;
  shallow?: boolean;
}

export interface NavigationLinksProps {
  className?: string;
  links: Link[];
  onItemClick?: (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    tracking: ClickTracking,
  ) => void;
}

export const NavigationLinks: FunctionComponent<NavigationLinksProps> = ({
  className,
  links,
  onItemClick,
}) => {
  const addTracking = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    tracking: ClickTracking,
  ) => {
    if (onItemClick) {
      onItemClick(event, tracking);
    }
  };
  const rootClassnames = classnames(styles.root, className);

  return (
    <Carousel
      className={rootClassnames}
      controlsClassName={styles.controls}
      titleClassName={styles.title}
      sliderClassName={styles.slider}
      title={title}
      dataTestId="navigation-links"
    >
      {links?.map((link, index) => (
        <ChipLink
          id={String(link.id)}
          key={link.id}
          label={link.name}
          href={link.url}
          className={styles.chip}
          onClick={addTracking}
          position={index + 1}
          dataTestid={`navigation-link-${index}`}
          colorTheme={link.isSelected ? 'light' : 'blue'}
          shallow={link.shallow}
        />
      ))}
    </Carousel>
  );
};

NavigationLinks.displayName = 'NavigationLinks';
